function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M270.852 371.704c0 9.2-7.728 19.504-19.504 19.504-7.728 0-14.72-4.416-17.664-11.776l-16.192-41.584H100.1l-16.192 41.584c-2.944 7.36-9.936 11.776-17.664 11.776-11.408 0-19.504-9.568-19.504-19.504 0-2.208.368-4.416 1.104-6.992l81.328-203.872c4.416-11.776 16.192-19.504 29.072-19.504 12.88-.368 25.024 7.36 29.808 19.504l81.328 203.872c1.104 2.576 1.472 4.784 1.472 6.992zm-63.664-65.872l-48.576-125.12-48.208 125.12h96.784zm243.248 69.184c0 8.832-7.36 16.192-16.56 16.192h-1.104c-6.624 0-15.088-5.52-15.088-16.192v-5.888c-14.352 15.824-34.592 24.288-58.512 24.288-29.44 0-61.824-19.872-61.824-58.88 0-40.112 32.384-58.144 61.824-58.144 24.288 0 44.528 7.728 58.512 23.552v-29.808c0-22.448-18.4-35.696-43.424-35.696-16.56 0-31.28 5.152-44.528 15.456-2.576 1.84-5.52 2.944-8.096 2.944-6.624 0-13.616-5.152-13.616-12.88 0-2.944 1.104-5.888 3.312-8.464 16.928-16.928 43.792-24.656 67.712-24.656 38.272 0 71.392 16.56 71.392 61.824v106.352zm-32.752-25.024v-30.176c-9.936-13.616-27.6-20.608-46-20.608-23.92 0-41.216 14.72-41.216 36.064 0 20.608 17.296 34.96 41.216 34.96 18.4 0 36.064-6.624 46-20.24z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgTextStyle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextStyle);
export default __webpack_public_path__ + "static/media/text-style.18105242.svg";
export { ForwardRef as ReactComponent };